import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Filter, X } from 'lucide-react';

interface FilterPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

export function FilterPanel({ isOpen, onClose }: FilterPanelProps) {
  const [filters, setFilters] = useState({
    dateRange: '30',
    agency: '',
    contractType: '',
    valueRange: '',
  });

  const handleApplyFilters = () => {
    // Apply filters logic would go here
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Filter Analytics">
      <div className="space-y-6">
        <div>
          <label htmlFor="dateRange" className="block text-sm font-medium text-gray-700">
            Date Range
          </label>
          <select
            id="dateRange"
            value={filters.dateRange}
            onChange={(e) => setFilters({ ...filters, dateRange: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 py-2 pl-3 pr-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
          >
            <option value="7">Last 7 days</option>
            <option value="30">Last 30 days</option>
            <option value="90">Last 90 days</option>
            <option value="365">Last 12 months</option>
          </select>
        </div>

        <div>
          <label htmlFor="agency" className="block text-sm font-medium text-gray-700">
            Agency
          </label>
          <select
            id="agency"
            value={filters.agency}
            onChange={(e) => setFilters({ ...filters, agency: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 py-2 pl-3 pr-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
          >
            <option value="">All Agencies</option>
            <option value="dod">Department of Defense</option>
            <option value="dhs">Department of Homeland Security</option>
            <option value="hhs">Health and Human Services</option>
          </select>
        </div>

        <div>
          <label htmlFor="contractType" className="block text-sm font-medium text-gray-700">
            Contract Type
          </label>
          <select
            id="contractType"
            value={filters.contractType}
            onChange={(e) => setFilters({ ...filters, contractType: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 py-2 pl-3 pr-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
          >
            <option value="">All Types</option>
            <option value="fixed">Fixed Price</option>
            <option value="cost">Cost Plus</option>
            <option value="time">Time & Materials</option>
          </select>
        </div>

        <div>
          <label htmlFor="valueRange" className="block text-sm font-medium text-gray-700">
            Contract Value Range
          </label>
          <select
            id="valueRange"
            value={filters.valueRange}
            onChange={(e) => setFilters({ ...filters, valueRange: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 py-2 pl-3 pr-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
          >
            <option value="">All Values</option>
            <option value="0-100k">$0 - $100K</option>
            <option value="100k-1m">$100K - $1M</option>
            <option value="1m-10m">$1M - $10M</option>
            <option value="10m+">$10M+</option>
          </select>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={() => setFilters({
              dateRange: '30',
              agency: '',
              contractType: '',
              valueRange: '',
            })}
            className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Reset
          </button>
          <button
            onClick={handleApplyFilters}
            className="inline-flex items-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700"
          >
            <Filter className="mr-2 h-4 w-4" />
            Apply Filters
          </button>
        </div>
      </div>
    </Modal>
  );
}